import { ZodiacAriesIcon } from './ZodiacAriesIcon';

/**
 * author: Michael Richins
 * id 8DC63282-63B3-4F4A-B976-2346FC3B7CFA
 * name zodiac-aries
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-aries.svg
 * tags
 */
export const HoroscopeAriesIcon = ZodiacAriesIcon;
export default HoroscopeAriesIcon